import React from 'react';
/*
 * PathCandles — draws a price path as a row of CANDLESTICKS instead of a line.
 * pts: [[x,y],...] in SVG coords (smaller y = higher price).
 * Each segment is cut into ~`step`px slices; each slice becomes one candle that
 * opens at the slice start and closes at the slice end (green = up, red = down),
 * with small wicks. Candles pop in one by one over `dur` seconds (replaces the old "draw" line).
 */
const GREEN = '#14a37f', RED = '#f0522e';
export function pathToCandles(pts, step = 11) {
  const out = [];
  for (let i = 1; i < pts.length; i++) {
    const [x0, y0] = pts[i - 1], [x1, y1] = pts[i];
    const n = Math.max(1, Math.round((x1 - x0) / step));
    for (let j = 0; j < n; j++) {
      const a = j / n, b = (j + 1) / n;
      const o = y0 + (y1 - y0) * a; let c = y0 + (y1 - y0) * b;
      // never draw doji-like slivers: every path candle gets a visible body (min 4.5px)
      if (Math.abs(c - o) < 4.5) c = o + (y1 > y0 || (y1 === y0 && j % 2) ? 4.5 : -4.5);
      const wick = 2 + ((i * 7 + j * 3) % 4); // deterministic small wick sizes
      out.push({ x: x0 + (x1 - x0) * (a + b) / 2, o, c, h: Math.min(o, c) - wick, l: Math.max(o, c) + wick, w: Math.min(7, Math.max(4, ((x1 - x0) / n) * 0.62)) });
    }
  }
  return out;
}
export function PathCandles({ pts, dur = 3, step = 11 }) {
  const cs = pathToCandles(pts, step);
  return <g className="path-candles">{cs.map((k, i) => {
    const col = k.c <= k.o ? GREEN : RED;
    return <g key={i} className="pop-svg" style={{ animationDelay: (i / cs.length) * dur + 's' }}>
      <line x1={k.x} x2={k.x} y1={k.h} y2={k.l} stroke={col} strokeWidth="1.6" />
      <rect x={k.x - k.w / 2} width={k.w} y={Math.min(k.o, k.c)} height={Math.max(Math.abs(k.o - k.c), 1.6)} fill={col} rx="1" />
    </g>; })}</g>;
}
